import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SEONavbar from './SEONavbar';
import SEOFooter from './SEOFooter';
import '../seo-pages.css';

/**
 * Layout wrapper for all SEO pages.
 * Provides consistent navbar + footer + scroll-to-top on route change.
 * 
 * Usage:
 * <SEOPageLayout>
 *   <SEO title="..." description="..." ... />
 *   <section className="seo-hero">...</section>
 *   <section className="seo-section">...</section>
 * </SEOPageLayout>
 */
export default function SEOPageLayout({ children }) {
  const { pathname } = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('seo-visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    const elements = document.querySelectorAll('.seo-animate');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, [pathname]);

  return (
    <div className="seo-page">
      <SEONavbar />
      <main>
        {children}
      </main>
      <SEOFooter />
    </div>
  );
}
